import { RouterProvider } from "react-router-dom";
import "@/utils/i18n.utils.ts";
import { useAppRouter } from "@/Router.tsx";
import { Toaster } from "./components/ui/Sonner/Toaster";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useBrandConfig } from "./utils/useBrandConfig";
import ReactGA from 'react-ga4';
import { useEffect } from "react";

export const queryClient = new QueryClient();

function App() {
  const router = useAppRouter();
  return (
    <>
      <Toaster />
      <QueryClientProvider client={queryClient}>
        <AnalyticsInitializer />
        <RouterProvider router={router} />
      </QueryClientProvider>
    </>
  )
}

function AnalyticsInitializer() {
  const config = useBrandConfig();
  const googleAnalyticsMeasurementId = config?.digitalWalletConfig.googleAnalyticsId || import.meta.env.VITE_APP_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (googleAnalyticsMeasurementId) {
      ReactGA.initialize(googleAnalyticsMeasurementId);
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
    }
  }, [googleAnalyticsMeasurementId]);

  return null;
}

export default App;
